import { Table, Tooltip, Typography } from "antd";
import routes from "@/routes";
import ContextMenu from "@/components/containers/ContextMenu";
import CollapsibleList from "@/components/ui/CollapsibleList";
import CustomLink from "@/components/ui/CustomLink";

const { Text } = Typography;

const disableDelete = (item) => {
  if (!item) return true;

  return Boolean(item.is_used);
};

const calcSortOrder = (sortedInfo, field) => {
  if (!sortedInfo) return null;

  const col = sortedInfo.find(({ columnKey }) => columnKey === field);

  return col ? col.order : null;
};

// Таблица категорий ключей НСПД
// Содержит список категорий с возможностью редактирования и удаления
const NSPDKeyCategoriesTable = ({
  data = [],
  loading = false,
  pagination,
  sortedInfo = [],
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      width: 200,
      sortOrder: calcSortOrder(sortedInfo, "name"),
      sorter: true,
      render: (value) => value || "—",
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      width: 350,
      render: (description) =>
        description ? (
          <Tooltip title={description}>
            <Text
              style={{
                display: "inline-block",
              }}
              ellipsis
            >
              {description}
            </Text>
          </Tooltip>
        ) : (
          <></>
        ),
    },
    {
      title: "Типы ресурсов",
      dataIndex: "definitions",
      key: "definitions",
      width: 300,
      render: (definitions = []) => {
        const definitionsList = definitions.filter((d) => d?.name);

        if (!definitionsList.length) return "";

        return (
          <CollapsibleList count={2} width={300}>
            {definitionsList.map((defInfo) => (
              <CustomLink
                key={defInfo.uuid}
                to={routes.administration.resourcesSettings.structures.definitionDetail(
                  defInfo.type,
                  defInfo.uuid,
                )}
              >
                {defInfo.name}
              </CustomLink>
            ))}
          </CollapsibleList>
        );
      },
    },
    {
      title: "",
      width: 40,
      fixed: "right",
      align: "center",
      key: "actions",
      render: (_, item) => (
        <>
          {disableDelete(item) ? (
            <ContextMenu vertical onEdit={() => onEditItem(item)} />
          ) : (
            <ContextMenu
              vertical
              onEdit={() => onEditItem(item)}
              onDelete={() => onDeleteItem(item)}
            />
          )}
        </>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      size="small"
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default NSPDKeyCategoriesTable;
